<template>
  <div class="user-post-wrap">
      <template v-if="posts.length">
        <el-card class="card-margin" shadow="hover" v-for="(post, index) in posts" :key="index+post.inner_id">
          <div slot="header" class="clearfix">
            <ul class="activity" v-if="post.activity_type">
              <li class="activity__item">
                Активность:
              </li>
              <li class="activity__item" v-for="(activity, index) in post.activity_type" :key="index">
                {{activity_type[index]}}: {{activity}}
              </li>
            </ul>
          </div>


          <post-header :post="post" class="post-header" style="padding-right: 40px"/>
          <post-body :post="post" :isRepost="false" @setTrust="setTrust"/>
          <post-header v-if="!!post.repost.id" :isRepost="!!post.repost.id" :post="post.repost" class="post-header" style="padding-right: 40px"/>
          <post-body v-if="post.repost.id" :post="post.repost" :isRepost="true" @setTrust="setTrust"/>

          <div class="post-info-panel">
            <span class="post-info-panel__item" @click="showPostInfo(post)">{{$t('post.postInfoPanel.analysis')}}</span>
            <span v-if="Number(post.comments)" class="post-info-panel__item" @click="toggleComment(post)">{{$t('post.postInfoPanel.comments')}} - {{post.comments}}</span>
          </div>

          <gallery v-if="post.images.length" :images="post.images"/>
          <template v-if="post.repost.id">
            <gallery v-if="post.repost.images.length" :images="post.repost.images"/>
          </template>

          <audio-gallery v-if="post.audio.length" :audios="post.audio" />
          <template v-if="post.repost.id">
            <audio-gallery v-if="post.repost.audio.length" :audios="post.repost.audio" />
          </template>

          <video-gallery v-if="post.video.length" :videos="post.video" />
          <template v-if="post.repost.id">
            <video-gallery v-if="post.repost.video.length" :videos="post.repost.video" />
          </template>

          <commentaries :post="post" v-if="!post.repost.id"/>
        </el-card>
      </template>
      <template v-else>
        <div class="posts__not-result">
          <i class="el-icon-search"></i> {{$t('post.noData')}}
        </div>
      </template>

    <el-dialog :title="`${$t('post.postInfoPanel.analysis')} ${selectedPost.title}`" :visible.sync="dialogPostInfo">
      <post-info :post="selectedPost" />
    </el-dialog>
  </div>
</template>

<script>
  // components
  import PostHeader from '../../../publicationsAndComments/components/PostHeader';
  import PostBody from '../../../publicationsAndComments/components/PostBody';
  import Commentaries from '../../../publicationsAndComments/components/Commentaries';
  import Gallery from '../../../publicationsAndComments/components/Gallery';
  import VideoGallery from '../../../publicationsAndComments/components/VideoGallery';
  import AudioGallery from '../../../publicationsAndComments/components/AudioGallery';
  import PostInfo from '../../../publicationsAndComments/components/PostInfo';

  export default {
    name: 'userPosts',
    props: {
      posts: {
        type: Array
      },
      loading: {
        type: Boolean
      }
    },
    data() {
      return {
        selectedPost: {},
        dialogPostInfo: false,
        trimTextLength: 400,
        activity_type: {
          comment: 'комментарий',
          like: 'лайк',
          post: 'пост',
          repost: 'репост',
        },
      };
    },
    methods: {
      showPostInfo(post) {
        this.selectedPost = {...this.selectedPost, ...post};
        this.dialogPostInfo = true;
      },
      getShowPost(showPost) {
        return !showPost ? 'hidePost' : '';
      },
      toggleComment(post) {
        this.$emit('toggleComment', post);
        console.log('post', post)
      },
      setTrust({postId, trust}) {
        this.$emit('setTrust', {postId, trust});
      },
    },
    components: {
      PostHeader,
      PostBody,
      Commentaries,
      Gallery,
      VideoGallery,
      AudioGallery,
      PostInfo,
    },
  };
</script>

<style>
  .user-post-wrap {
    padding-top: 20px;
    min-height: 100px;
  }
  .card-margin {
    margin-bottom: 20px;
    position: relative;
  }
  .post-header {
    margin-bottom: 20px;
  }

  .post-info-panel {
    display: flex;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    color: #1F2F3D;
    margin-left: 45px;
    padding: 15px 0 0 10px;
  }

  .post-info-panel__item {
    cursor: pointer;
  }
  .post-info-panel__item:last-child {
    margin-right: 0;
  }
  .posts__not-result {
    border-top: 1px solid #ccc;
    padding-top: 20px;
  }
  .to-ex {
    margin-left: auto;
  }

  .activity {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
  }

  .activity__item {
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #1F2F3D;
    margin-right: 10px;
  }

  .activity__item:first-child {
    font-weight: 600;
    margin-right: 15px;
  }

  @media screen and (max-width: 480px) {
    .post-info-panel {
      padding: 0;
    }
    .post-info-panel__item:last-child {
        max-width: 50px;
    }
    .post-info-panel--mobile {
      display: flex;
      display: none;
    }
    .to-ex {
      margin-left: 0;
    }
  }
</style>
